import React from 'react';
import './InstanceDialog.css';

interface InstanceDialogProps {
  show: boolean;
  editingId: string | null;
  formData: {
    name: string;
    mongo_url: string;
    milvus_url: string;
    is_default: boolean;
  };
  onSubmit: (e: React.FormEvent) => void;
  onChange: (data: { name?: string; mongo_url?: string; milvus_url?: string; is_default?: boolean }) => void;
  onClose: () => void;
}

function InstanceDialog({ show, editingId, formData, onSubmit, onChange, onClose }: InstanceDialogProps) {
  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content edit-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h2>{editingId ? '✏️ Editar Instância' : '➕ Adicionar Nova Instância'}</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <form id="instance-form" onSubmit={onSubmit} className="dialog-form">
          <div className="form-grid">
            <div className="form-group">
              <label>Nome:</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => onChange({ name: e.target.value })}
                placeholder="Ex: Produção, Desenvolvimento..."
                required
              />
            </div>
            
            <div className="form-group">
              <label>URL MongoDB:</label>
              <input
                type="text"
                value={formData.mongo_url}
                onChange={(e) => onChange({ mongo_url: e.target.value })}
                placeholder="mongodb://user:password@host:port/database"
                required
              />
            </div>

            <div className="form-group">
              <label>URL Milvus:</label>
              <input
                type="text"
                value={formData.milvus_url}
                onChange={(e) => onChange({ milvus_url: e.target.value })}
                placeholder="http://host:port"
                required
              />
            </div>

            <div className="form-group checkbox-group">
              <label>
                <input
                  type="checkbox"
                  checked={formData.is_default}
                  onChange={(e) => onChange({ is_default: e.target.checked })}
                />
                <span>Definir como instância padrão</span>
              </label>
            </div>
          </div>
        </form>
        
        <div className="dialog-actions">
          <button type="submit" form="instance-form" className="btn-primary">
            💾 {editingId ? 'Salvar' : 'Criar'}
          </button>
          <button 
            type="button" 
            className="btn-secondary"
            onClick={onClose}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

export default InstanceDialog;

